/// <reference types="@angular/localize" />

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import '@angular/localize/init';

if (localStorage.getItem('sentry.is_active') != null || environment.production) {
  Sentry.init({
    dsn: 'https://b32bbfb6ebbd47d887a7adf34edad9cd@o4504216192614400.ingest.sentry.io/4504710372851712',
    integrations: [
      // Registers and configures the Tracing integration,
      // which automatically instruments your application to monitor its
      // performance, including custom Angular routing instrumentation
      Sentry.browserTracingIntegration(),
      // Registers the Replay integration,
      // which automatically captures Session Replays
      Sentry.replayIntegration(),
      Sentry.feedbackIntegration({
          colorScheme: 'system',
        autoInject: false,
        formTitle: 'Rapporter un bogue',
        submitButtonLabel: 'Soumettre',
        cancelButtonLabel: 'Annuler',
        confirmButtonLabel: 'Confirmer',
        addScreenshotButtonLabel: 'Ajouter une capture d\'écran',
        removeScreenshotButtonLabel: 'Enlever la capture d\'écran',
        nameLabel: 'Nom',
        namePlaceholder: 'Votre nom',
        emailLabel: 'Courriel',
        emailPlaceholder: 'jean.tremblay@gmail.com',
        isRequiredLabel: 'Requis',
        messageLabel: 'Description',
        messagePlaceholder: 'Quel est le problème? Décrivez ce à quoi vous vous attendiez.',
        successMessageText: 'Merci infiniment!',
      }),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,
    // Called for message and error events
    beforeSend(event) {
      // Modify or drop the event here
      if (event && event.user && event.user.email && event.user.email.endsWith('optitax.ca')) {
        // Prevent Sentry from logging errors for Optitax users
        return null;
      }
      return event;
    },
  });

  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
